import {
  LibraryCollectionItem,
  LibraryItemRef,
  toLibraryMemberStoredKind,
} from '@digital-twins/shared-types'

export const COLLECTION_SELECTION_MAX = 200
export const COLLECTION_SUGGESTIONS_MAX = 8

/** Dataset and document refs share one stored identity. */
export function collectionItemKey(ref: LibraryItemRef): string {
  return `${toLibraryMemberStoredKind(ref.kind)}:${ref.token.toLowerCase()}`
}

/** Preserve the first reference and order. Oversized seeds remain visible, never truncated. */
export function dedupeCollectionSelection(refs: Array<LibraryItemRef>): Array<LibraryItemRef> {
  const seen = new Set<string>()
  return refs.filter(ref => {
    const key = collectionItemKey(ref)
    if (seen.has(key)) return false
    seen.add(key)
    return true
  }).map(ref => ({ kind: ref.kind, token: ref.token }))
}

export function collectionSelectionKey(refs: Array<LibraryItemRef>): string {
  return dedupeCollectionSelection(refs).map(collectionItemKey).join('|')
}

export function toggleCollectionSelection(refs: Array<LibraryItemRef>, ref: LibraryItemRef): Array<LibraryItemRef> {
  const unique = dedupeCollectionSelection(refs)
  const key = collectionItemKey(ref)
  if (unique.some(item => collectionItemKey(item) === key)) {
    return unique.filter(item => collectionItemKey(item) !== key)
  }
  return unique.length >= COLLECTION_SELECTION_MAX ? unique : [...unique, { kind: ref.kind, token: ref.token }]
}

/** Server order within each kind, one row per kind per round, independent of arrival order. */
export function interleaveCollectionCandidates(pages: Array<Array<LibraryCollectionItem>>): Array<LibraryCollectionItem> {
  const rows: Array<LibraryCollectionItem> = []
  const seen = new Set<string>()
  const length = Math.max(0, ...pages.map(page => page.length))
  for (let index = 0; index < length; index += 1) {
    for (const page of pages) {
      const item = page[index]
      if (!item) continue
      const key = collectionItemKey(item)
      if (seen.has(key)) continue
      seen.add(key)
      rows.push(item)
      if (rows.length === COLLECTION_SUGGESTIONS_MAX) return rows
    }
  }
  return rows
}
